import { render, staticRenderFns } from "./bindMphone.vue?vue&type=template&id=68231227&scoped=true&"
import script from "./bindMphone.vue?vue&type=script&lang=js&"
export * from "./bindMphone.vue?vue&type=script&lang=js&"
import style0 from "./bindMphone.vue?vue&type=style&index=0&id=68231227&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68231227",
  null
  
)

export default component.exports